<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">
    <div class="card-body">
      <div *ngIf="showDealerList" class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="email-input">Store</label><span class="required">*</span>
            <ng-select (change)="setDealerInfo($event)"
                       [clearable]="false"
                       [items]="dealerList"
                       bindLabel="name"
                       class="form-control address-button me-2 add-btn"
                       placeholder="Select Store">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="email-input">Username(Email)</label><span class="required">*</span>
            <input (blur)="checkEmail($event)"
                   class="form-control"
                   formControlName="email"
                   id="email-input"
                   placeholder="Email"
                   type="text">
            <dp-field-error [formField]="form['email']"></dp-field-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="firstName-input">First Name</label><span class="required">*</span>
            <input class="form-control" formControlName="firstName" id="firstName-input" placeholder="First name"
                   type="text">
            <dp-field-error [formField]="form['firstName']"></dp-field-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="lastName-input">Last Name</label><span class="required">*</span>
            <input class="form-control" formControlName="lastName" id="lastName-input" placeholder="Last name"
                   type="text">
            <dp-field-error [formField]="form['lastName']"></dp-field-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="tel-input">Phone #</label><span
            class="required">{{ [companies.SeaIm].includes(company) ? '*' : '' }}</span>
            <div class="d-flex">
              <input class="form-control phone-number" formControlName="tel" id="tel-input"
                     placeholder="Only 10 digit numbers allowed"
                     minlength="10"
                     maxlength="10"
                     type="text">
              <input class="form-control phone-number-ext ml-8px" formControlName="ext" id="ext-input"
                     placeholder="Ext."
                     type="text">
            </div>
            <dp-field-error [formField]="form['tel']"></dp-field-error>
          </div>
        </div>
        <div *ngIf="[companies.Sea].includes(company)" class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="employeeNo-input">Employee Number</label>
            <input class="form-control" formControlName="employeeNo" id="employeeNo-input" placeholder="Employee Number"
                   type="text">
            <dp-field-error [formField]="form['employeeNo']"></dp-field-error>
          </div>
        </div>
      </div>
      <div class="row" style="width: 106%;">
        <ng-container *ngIf="!showDealerList">
          <div *ngIf="!hq && [companies.Sea].includes(company)" class="row">
            <div class="col-md-12">
              <div class="mb-3 position-relative">
                <label for="email-input">Stores</label>
                <div>
                  <ng-select [closeOnSelect]="false"
                             [items]="allStores"
                             [multiple]="true"
                             bindLabel="name"
                             bindValue="code"
                             class="form-control"
                             formControlName="stores"
                             id="stores-input"
                             placeholder="Stores">
                  </ng-select>
                </div>
                <dp-field-error [formField]="form['stores']"></dp-field-error>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="[companies.Seca, companies.SeaIm].includes(company)" class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="email-input">Role</label>
            <div>
              <ng-select [items]="roles"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="role"
                         id="role-input"
                         placeholder="Role">
              </ng-select>
            </div>
            <dp-field-error [formField]="form['role']"></dp-field-error>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="width: 106%;">
      <div class="mb-3 position-relative">
        <input
               class="form-check-input"
               formControlName="optOut"
               id="dealerStoreAll" type="checkbox"/>
        <label class="form-check-label pl-4x" for="dealerStoreAll">I don't want to get message from Samsung.</label>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button (click)="submitForm($event)" class="btn btn-dark button-large" type="submit">{{ buttonLabel }}</button>
</div>
